import { __assign, __generator, __rest } from "tslib";
import { all, takeEvery, select, put } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { fetchNext, fetchPrevious, fetchAll, initializeIfNeeded, } from './actions';
import { getStream, isInitialized, canStreamAutoFetch } from './selectors';
import * as offsetActions from '../withOffset/actions';
import * as cursorActions from '../withCursor/actions';
import { StreamType } from '../types';
import { createCallbackActionCreator } from '../helpers';
function getActionsForStreamType(type) {
    switch (type) {
        case StreamType.WITH_OFFSET:
            return offsetActions;
        case StreamType.WITH_CURSOR:
            return cursorActions;
        default:
            return {};
    }
}
function getFetchActionForDirection(actions, direction) {
    switch (direction) {
        case 'all':
            return actions.fetchAll;
        case 'prev':
            return actions.fetchPrevious;
        case 'next':
        default:
            return actions.fetch;
    }
}
function getFetchActionForStreamType(type, direction) {
    var actions = getActionsForStreamType(type);
    var action = getFetchActionForDirection(actions, direction);
    if (!action) {
        ddt.warn('stream', 'Unknown stream type or action', type, direction);
        return function (streamId) {
            return ({ streamId: streamId, type: 'STREAM__UNKNOWN_TYPE__FETCH' });
        }; // no idea what this type is, noop
    }
    return action;
}
function handleFetchNext(_a) {
    var stream, fetchAction;
    var streamId = _a.payload.streamId;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getStream, streamId)];
            case 1:
                stream = _b.sent();
                if (!stream || !stream.hasMore || stream.errorMsg || !stream.streamType) {
                    return [2 /*return*/];
                }
                fetchAction = getFetchActionForStreamType(stream.streamType, 'next');
                // kick off the reducers and any legacy handlers
                return [4 /*yield*/, put(fetchAction(streamId))];
            case 2:
                // kick off the reducers and any legacy handlers
                _b.sent();
                if (!stream.fetchNextCallback) return [3 /*break*/, 4];
                return [4 /*yield*/, put(createCallbackActionCreator(stream.fetchNextCallback)(streamId))];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
function handleFetchPrev(_a) {
    var stream, fetchAction;
    var streamId = _a.payload.streamId;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getStream, streamId)];
            case 1:
                stream = _b.sent();
                if (!stream || !stream.hasLess || stream.errorMsg || !stream.streamType) {
                    return [2 /*return*/];
                }
                fetchAction = getFetchActionForStreamType(stream.streamType, 'prev');
                // kick off the reducers and any legacy handlers
                return [4 /*yield*/, put(fetchAction(streamId))];
            case 2:
                // kick off the reducers and any legacy handlers
                _b.sent();
                if (!stream.fetchPreviousCallback) return [3 /*break*/, 4];
                return [4 /*yield*/, put(createCallbackActionCreator(stream.fetchPreviousCallback)(streamId))];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
function handleFetchAll(_a) {
    var stream, fetchAction;
    var streamId = _a.payload.streamId;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getStream, streamId)];
            case 1:
                stream = _b.sent();
                if (!stream ||
                    !(stream.hasMore || stream.hasLess) ||
                    stream.errorMsg ||
                    !stream.streamType) {
                    return [2 /*return*/];
                }
                fetchAction = getFetchActionForStreamType(stream.streamType, 'all');
                // kick off the reducers and any legacy handlers
                return [4 /*yield*/, put(fetchAction(streamId))];
            case 2:
                // kick off the reducers and any legacy handlers
                _b.sent();
                if (!stream.fetchAllCallback) return [3 /*break*/, 4];
                return [4 /*yield*/, put(createCallbackActionCreator(stream.fetchAllCallback)(streamId))];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
function handleInitIfNeeded(_a) {
    var actions, isInit, canAutoFetch;
    var _b = _a.payload, streamType = _b.streamType, autoFetch = _b.autoFetch, initParams = __rest(_b, ["streamType", "autoFetch"]);
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                actions = getActionsForStreamType(streamType);
                return [4 /*yield*/, select(isInitialized, initParams.streamId)];
            case 1:
                isInit = _c.sent();
                if (!(!isInit && actions.initialize)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(actions.initialize(__assign({ items: [], hasMore: true }, initParams)))];
            case 2:
                _c.sent();
                _c.label = 3;
            case 3: return [4 /*yield*/, select(canStreamAutoFetch, initParams.streamId)];
            case 4:
                canAutoFetch = _c.sent();
                if (!(autoFetch && canAutoFetch)) return [3 /*break*/, 6];
                return [4 /*yield*/, put(fetchNext(initParams.streamId))];
            case 5:
                _c.sent();
                _c.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
export default function baseStreamSaga(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(fetchNext, handleFetchNext),
                    takeEvery(fetchPrevious, handleFetchPrev),
                    takeEvery(fetchAll, handleFetchAll),
                    takeEvery(initializeIfNeeded, handleInitIfNeeded),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=sagas.js.map